/**
 * Hook for managing league leaderboard data
 */

import { useState, useEffect } from 'react';
import { getCurrentLeaderboard, type LeagueLeaderboard, type LeaguePreview } from '../services/leagueService';

interface UseLeagueReturn {
  leaderboard: LeagueLeaderboard | null;
  preview: LeaguePreview | null;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useLeague = (): UseLeagueReturn => {
  const [leaderboard, setLeaderboard] = useState<LeagueLeaderboard | null>(null);
  const [preview, setPreview] = useState<LeaguePreview | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchLeaderboard = async () => {
    try {
      setLoading(true);
      setError(null);

      const data = await getCurrentLeaderboard();
      setPreview(data);
      setLeaderboard(data.leaderboard);
    } catch (err) {
      const message = err instanceof Error ? err.message : 'خطا در دریافت اطلاعات لیگ';
      setError(message);
      console.error('❌ [useLeague] Error fetching leaderboard:', err);
    } finally {
      setLoading(false);
    }
  };

  const refetch = async () => {
    await fetchLeaderboard();
  };

  useEffect(() => {
    fetchLeaderboard();
  }, []);

  return {
    leaderboard,
    preview,
    loading,
    error,
    refetch,
  };
};

